<template>
  <div class="p-index">
    <div class="banner">
      <img
        src="./img/banner.png"
        alt="banner"
      />
    </div>
    <div class="wrap limit">
      <SearchBox @on:search="onSearch" />
    </div>
  </div>
</template>

<script>
import storage from '@/assets/js/storage/storage';

export default {
  name: 'Search',
  components: {
    SearchBox: () => import('@/views/search/SearchBox.vue'),
  },
  methods: {
    onSearch(path, query) {
      this.$router.push({ path, query: { ...query } });
    },

    // 根据url参数获取当前语言环境
    getLangInUrl() {
      const { query } = this.$route;
      let { lang } = query;
      if (lang !== 'en' && lang !== 'zh') {
        lang = -1;
      }
      return lang;
    },
  },
  created() {
    const lang = this.getLangInUrl();
    if (lang !== -1) {
      this.$root.$i18n.locale = lang;
      this.$store.dispatch('updateLang', lang);
      storage.setItem('lang', lang);
    }
  },
};
</script>

<style scoped lang="scss">
@import '../../assets/css/color.scss';
@import '../../assets/css/util.scss';

.p-index {
  background-color: #fff;
  position: relative;

  .wrap {
    padding-top: px2rem(20);
    padding-bottom: px2rem(30);
    box-sizing: border-box;
    width: 100%;
  }

  .banner {
    width: 100%;

    img {
      width: 100%;
    }
  }

  /deep/ .cp-search-box {
    width: 550px;
    box-sizing: border-box;
    position: relative;
    z-index: 2;
    border-radius: 5px;
    border: 1px solid #eee;
    box-shadow: 0 0 8px 0 #eee;

    .flexbox .dropbox {
      max-width: 200px;
    }
  }
}
</style>
